import { render, staticRenderFns } from "./flowShipmentAct copy.vue?vue&type=template&id=221fc636&scoped=true"
import script from "./flowShipmentAct copy.vue?vue&type=script&lang=js"
export * from "./flowShipmentAct copy.vue?vue&type=script&lang=js"
import style0 from "./flowShipmentAct copy.vue?vue&type=style&index=0&id=221fc636&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221fc636",
  null
  
)

export default component.exports